var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CFActionFooter, CFCheckbox, CFIcon, CFListItem, } from '../../../components';
import { CFSelectFieldElements } from '../SelectField.styles';
export const SelectFieldFlyout = ({ allowMultiple = false, confirmationLabel, label, options, onConfirmSelection, onSelectOption, placeholder, size = 10, width, }) => {
    const { SelectFieldFlyout, SelectFieldOptionList, SelectFieldOptionListLabel, } = CFSelectFieldElements;
    const flyoutLabel = (() => {
        if (label)
            return label;
        return label === undefined
            ? placeholder
            : undefined;
    })();
    return (React.createElement(SelectFieldFlyout, { width: width },
        flyoutLabel && (React.createElement(SelectFieldOptionListLabel, null, flyoutLabel)),
        React.createElement(SelectFieldOptionList, { allowMultiple: allowMultiple, size: size }, options === null || options === void 0 ? void 0 : options.map((_a) => {
            var { icon, id, label, selected } = _a, rest = __rest(_a, ["icon", "id", "label", "selected"]);
            return (React.createElement(CFListItem, { key: id, children: typeof label !== 'string' ? label : undefined, onClick: () => onSelectOption(Object.assign({ id,
                    label, selected: allowMultiple ? !selected : true }, rest)), selected: allowMultiple ? false : selected, slotLeft: icon ? React.createElement(CFIcon, { icon: icon }) : undefined, slotRight: allowMultiple ? React.createElement(CFCheckbox, { checked: selected }) : undefined, title: typeof label === 'string' ? label : undefined }));
        })),
        allowMultiple && confirmationLabel && (React.createElement(CFActionFooter, { items: [
                {
                    children: confirmationLabel,
                    onClick: onConfirmSelection,
                    widthPreset: 'full',
                },
            ] }))));
};
